// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16bdQ","toggle":"styles_toggle__3AxQC","preview":"styles_preview__dytYN"};